import InputMask from 'react-input-mask';
import React from 'react';
import { Input, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';

function InputVerificationCode(props) {
  return (<InputMask value={props.value} onChange={props.onChange}>
    {(inputProps) => <InputGroup className="mb-3">
      <InputGroupAddon addonType="prepend">
        <InputGroupText>
          <i className="icon-lock"></i>
        </InputGroupText>
      </InputGroupAddon>
      <Input onChange={props.onChange} maxLength={6} name="verification_code" type="text" placeholder={props.placeholder} />
    </InputGroup>
    }
  </InputMask>
  );
}
export default InputVerificationCode;
